// extracted by mini-css-extract-plugin
export default {"root":"AmenityCategoryItem_root__LtVko"};